import React from 'react';
import { YELLOW } from '../../HOME/const';

const SVG = ({ style = {}, color = YELLOW, on, width = '100%', viewBox = '0 0 100 100' }) => {
  const clipPath = `url(#hints-${on ? '' : 'no'}clip)`;

  return (
    <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
      <g stroke={color}>
        <g clipPath={clipPath}>
          <defs>
            <clipPath id="hints-noclip">
              <rect x="0" y="0" width="100" height="100" />
            </clipPath>
            <clipPath id="hints-clip">
              <rect x="0" y="0" width="75" height="100" />
              <rect x="0" y="35" width="100" height="65" />
            </clipPath>
          </defs>
          <circle cx="50" cy="50" r="46" fill="transparent" strokeWidth={8} />
        </g>
        <polyline points="55,22 70,35 94,14" strokeWidth={10} opacity={on ? 1 : 0} />
        <polyline points="32,21 32,67 78,67" strokeWidth={6} />
        <line x1="32" y1="21" x2="78" y2="67" strokeWidth={2} />
      </g>
    </svg>
  );
};

export default SVG;
